module.exports = __webpack_public_path__ + "img/zgzq.287beb91.png";